export default __webpack_public_path__ + "static/media/howard_kapiloff_head.88a48706.jpg";